import React from 'react';
import { Card, ExamWithPayment } from 'components';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { useLocalErrorHandler } from 'hooks';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import query from '../../helpers/const/query';

const ExamWithPaymentContainer = ({
    apiError,
    examsPaymentList,
    getExamsWithPaymentList,
    fetchExamDetailsWithPayment,
    examPaymentDetails,
    setErrorHandler,
    onPush,
}: Props) => {
    useLocalErrorHandler(setErrorHandler);

    const [processing, setProcessing] = React.useState(false);

    React.useEffect(() => {
        const fetch = async () => {
            setProcessing(true);
            await getExamsWithPaymentList({});
            setProcessing(false);
        };

        fetch();
    }, []);

    return (
        <Card
          title="Взаиморасчеты с СПКФР"
          category="Список утвержденных экзаменов и расчетов с СПКФР"
          apiError={apiError}
          showLoader={processing}
          withoutPadding
        >
            <ExamWithPayment
              examsPaymentList={examsPaymentList}
              getExamsWithPaymentList={getExamsWithPaymentList}
              onPush={onPush}
              from={query.FROM.EXAM_PAYMENT}
              getExamDetailsWithPayment={fetchExamDetailsWithPayment}
              examWithPaymentDetails={examPaymentDetails}
            />
        </Card>
    );
};

const mapState = (state: IRootState) => ({
    examsPaymentList: state.exam.examsPayment,
    examPaymentDetails: state.exam.examPaymentDetails,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    getExamsWithPaymentList: dispatch.exam.fetchExamsWithPaymentListAsync,
    setErrorHandler: dispatch.errors.setErrorHandler,
    fetchExamDetailsWithPayment: dispatch.exam.fetchExamDetailsWithPaymentAsync,
    onPush: (key: string) => dispatch(push(key)),
});

export default connect(mapState, mapDispatch)(ExamWithPaymentContainer);

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>
type Props = connectedProps;
